export enum ModalNames {
  LoginModal = "LoginModal",
  ConfirmationModal = "ConfirmationModal",
  BuySubscriptionModal = "BuySubscriptionModal",
  Result = "Result",
  PreviewModal = "PreviewModal",
  CopyLinkModal = "CopyLinkModal",
  InProgressService = "InProgressService",
  DiscountableConfirmationModal = "DiscountableConfirmationModal",
  AIModelsModal = "AIModelsModal",
  LogoutModal = "LogoutModal",
  WalletCashInModal = "WalletCashInModal",
  AnnouncedNotification = "AnnouncedNotification",
  PreviewGeneratedImage = "PreviewGeneratedImage",
  PersonalizationModal = "PersonalizationModal",
  BuyExtraTokensModal = "BuyExtraTokensModal",
  PreviewSampleModal = "PreviewSampleModal",
  TokenHistoryDetailsModal = "TokenHistoryDetailsModal",
  ReferralCodeModal = "ReferralCodeModal",
  ResourcesModal = "ResourcesModal",
  DeleteKnowledgeModal = "DeleteKnowledgeModal",
  RawDataContentModal = "RawDataContentModal",
}
